import moment from 'moment';

import * as Validator from '../../../utils';
import { YEARS, DD_MM_YYYY } from '../../../timeConstants';

import { MIN_ALLOWED_AGE,
  MAX_DISABILITY_INSURED_AMOUNT,
  MIN_DISABILITY_INSURED_AMOUNT,
  MIN_ALLOWED_INSURANCE_DURATION,
  MAX_ALLOWED_INSURANCE_DURATION,
  MAX_ALLOWED_INSURANCE_DURATION_TEXT,
  MAX_ALLOWED_END_POLICY_AGE,
  MAX_ALLOWED_AGE,
  MAX_ALLOWED_INSURED_AMOUNT_TEXT,
  MIN_ALLOWED_AGE_TEXT,
  MAX_DISABILITY_INSURED_AMOUNT_TEXT,
  MAX_ALLOWED_END_AGE_TEXT } from './enums';

export const validate = (values) => {
  const errors = {};
  if (!values.sumAssured
      || !Validator.isValueInRange(values.sumAssured,
        MIN_DISABILITY_INSURED_AMOUNT, MAX_DISABILITY_INSURED_AMOUNT)
      || !Number.isInteger(+values.sumAssured)
  ) {
    errors.sumAssured = MAX_ALLOWED_INSURED_AMOUNT_TEXT;
  }
  if (!values.dateOfBirthDay || !Validator.isValueInRange(moment()
    .diff(Validator.parseInputToDate(values.dateOfBirthDay), YEARS), MIN_ALLOWED_AGE, MAX_ALLOWED_AGE)) {
    errors.dateOfBirthDay = MIN_ALLOWED_AGE_TEXT;
  }
  if (!values.unemploymentSumAssured
      || !Validator.isValueInRange(values.unemploymentSumAssured,
        MIN_DISABILITY_INSURED_AMOUNT, MAX_DISABILITY_INSURED_AMOUNT)
      || Validator.isPercentOverMaxValue(+values.unemploymentSumAssured, +values.sumAssured, 125)
      || !Number.isInteger(+values.unemploymentSumAssured)
  ) {
    errors.unemploymentSumAssured = MAX_DISABILITY_INSURED_AMOUNT_TEXT;
  }

  if (!values.endDate
      || Validator.calculateInsuranceEndDate(values.dateOfBirthDay)
        .isBefore(moment(values.endDate, DD_MM_YYYY))
      || Validator.isAfterLastDayOfMonth(values.endDate)
  ) {
    errors.endDate = MAX_ALLOWED_END_AGE_TEXT;
  }
  if (!Validator.isValueInRange(moment(values.endDate, DD_MM_YYYY)
    .diff(moment(values.startDate, DD_MM_YYYY), YEARS),
  MIN_ALLOWED_INSURANCE_DURATION, MAX_ALLOWED_INSURANCE_DURATION)
    && !errors.endDate
  ) {
    errors.endDate = MAX_ALLOWED_INSURANCE_DURATION_TEXT;
  }
  if (!Validator.isAllowedDate(Validator.parseInputToDate(values.dateOfBirthDay).getFullYear(),
    new Date().getFullYear() + parseInt(values.looptijd, 10), MAX_ALLOWED_END_POLICY_AGE)) {
    errors.looptijd = MAX_ALLOWED_END_AGE_TEXT;
  }
  return errors;
};
